import React from 'react';
import { Avatar } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';

interface FilePreviewProps extends Omit<React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>, | 'src' | 'onLoad'> {
  file: File,
}

export const FilePreview: React.FC<FilePreviewProps> = (props: FilePreviewProps) => {

  const { file, ...rest } = props;
  const previewSrc = URL.createObjectURL(file);

  const isVideoFile = file.type.startsWith('video/');

  return (
    <>
      {isVideoFile ?
        <Avatar>< VideocamIcon /></Avatar > :
        <img src={previewSrc} onLoad={() => { URL.revokeObjectURL(previewSrc); }} {...rest} />
      }
    </>
  );
};